/* eslint-disable camelcase */
import React, { useState } from 'react';

import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useBreakpoints } from '@hooks/NewBreakpoint';
import { useAuth } from '@hooks';
import useCommon from '@hooks/useCommon';
import { ConfirmationModal } from '@components';
import { RolIs } from './RolIs';
import { RolIsMobile } from './RolIsMobile';

const Table = styled.div`
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 6px 12px -3px rgba(0, 51, 102, 0.08), 0px 10px 30px 0px rgba(68, 75, 98, 0.2);
  width: 253px;
  padding: 0px 0px 16px 0px;
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  color: #505050;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 8px;
  padding: 0px 24px;
`;

const LinkPage = styled.div`
  color: #707070;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 8px 0px 8px 0px;
  display: flex;
  width: 100%;
  padding: 8px 24px;
  justify-content: flex-start;
  cursor: pointer;
  &:hover {
    background: #ebebeb;
  }
`;

const LinkNeedHelpCo = styled.a`
  color: #707070;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 8px 0px 8px 0px;
  display: flex;
  width: 100%;
  padding: 8px 24px;
  justify-content: flex-start;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background: #ebebeb;
  }
`;

const Line = styled.hr`
  display: flex;
  width: calc(100% - 48px);
  margin: 10px auto;
  opacity: 0.2;
  padding: 0;
`;

export const MenuDropDown = () => {
  const { breakpoint } = useBreakpoints();
  const { doLogout, isAllowed } = useAuth();
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const history = useHistory();
  const { setModal } = useCommon();
  const handleDoLogout = () => {
    setIsOpenMenu(false);
    setModal({
      body: <ConfirmationModal title="logoutModal.text" handleConfirm={doLogout} />,
    });
  };

  const { t } = useTranslation();

  return (
    <Table>
      {breakpoint === 'xs' ? <RolIsMobile /> : <RolIs />}
      {isAllowed('CONFIGURATION') && (
        <>
          <Title>{t('headerDropdown.configurationTitle')}</Title>
          {isAllowed('MERCHANT_ACCOUNT') && (
            <LinkPage
              id="header-dropdown-commerce-data"
              onClick={() => history.push('/configuration-commerce-info')}
            >
              {t('headerDropdown.accountData')}
            </LinkPage>
          )}
          {isAllowed('DOCUMENTS') && (
            <LinkPage onClick={() => history.push('/configuration-documentation')}>
              {t('headerDropdown.documentation')}
            </LinkPage>
          )}
          {isAllowed('USERS') && (
            <LinkPage
              id="header-dropdown-collaborators"
              onClick={() => history.push('/configuration-users')}
            >
              {t('headerDropdown.colaborators')}
            </LinkPage>
          )}
          <Line />
        </>
      )}
      {isAllowed('HELP') && (
        <>
          <LinkNeedHelpCo
            id="header-dropdown-help"
            href={t('needHelp.needHelpUrl')}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t('needHelp.needHelp')}
          </LinkNeedHelpCo>
          <Line />
        </>
      )}
      <LinkPage id="header-dropdown-sign-off" onClick={handleDoLogout}>
        {t('headerDropdown.close')}
      </LinkPage>
    </Table>
  );
};

export default MenuDropDown;
